let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("80chk")).then(() => parcelRequire('58v4x'));